import React from 'react';
import { Box, Typography } from '@mui/material';

const Welcome = () => {
    return (
        <>
            <Typography variant="h2" style={{ fontSize: '2.5rem' }}>
                Welcome to the ED3N Educate Page
            </Typography>
            <Box mt={2}>
                <Typography variant="body1" style={{ fontSize: '1rem' }}>
                    Please select a topic from the left panel to view.
                </Typography>
            </Box>
        </>
    );
};

export default Welcome;